import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./globalStyle/type.css";
import "./globalStyle/color.css";
import "./globalStyle/components.css";
import "@mantine/notifications/styles.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MantineProvider } from "@mantine/core";
import { theme } from "./globalStyle/theme.js";
import { ThemeProvider } from "@emotion/react";
import { Notifications } from "@mantine/notifications";
import "./i18n/config";
import { UserProvider } from "./contexts/UserContext";
import { ThreadsProvider } from "./contexts/ThreadsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Production 환경에서 console 로그 비활성화 (최우선 실행)
if (process.env.NODE_ENV === "production") {
	console.log = () => {};
	console.info = () => {};
	console.debug = () => {};
	console.trace = () => {};
	// console.warn과 console.error는 중요한 에러 정보이므로 유지
  }

root.render(
  <MantineProvider withGlobalStyles withNormalizeCSS theme={theme}>
    <ThemeProvider theme={theme}>
      <Notifications position="bottom-center" zIndex={1000} />
      <UserProvider>
        <ThreadsProvider>
          <App />
        </ThreadsProvider>
      </UserProvider>
    </ThemeProvider>
  </MantineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
